import { render } from "./Purpose.vue?vue&type=template&id=6d843e5c&scoped=true&ts=true"
import script from "./Purpose.vue?vue&type=script&lang=ts"
export * from "./Purpose.vue?vue&type=script&lang=ts"

import "./Purpose.vue?vue&type=style&index=0&id=6d843e5c&scoped=true&lang=css"

import exportComponent from "/builds/otto-tech/otto-financas-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d843e5c"]])

export default __exports__